/* =====================================================================
   CHLOROFRIENDS · Header behavior
   - sticky shrink (is-scrolled) via scroll position
   - openable overlays: mobile nav, search, cart (one controller)
   - focus trap, ESC to close, backdrop click, body scroll lock
   Reduced motion is handled in CSS; this only toggles classes.
   ===================================================================== */
(function () {
  'use strict';

  var header = document.querySelector('.cf-header');
  if (!header) return;

  /* ---- sticky shrink ---- */
  var onScroll = function () {
    header.classList.toggle('is-scrolled', window.scrollY > 24);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---- overlay controller ---- */
  var backdrop = document.querySelector('.cf-backdrop');
  var openPanel = null;
  var lastFocus = null;

  var FOCUSABLE = 'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])';

  function trap(e) {
    if (e.key !== 'Tab' || !openPanel) return;
    var items = openPanel.querySelectorAll(FOCUSABLE);
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(panel, trigger) {
    if (openPanel) close();
    openPanel = panel;
    lastFocus = trigger || document.activeElement;
    panel.classList.add('is-open');
    panel.removeAttribute('aria-hidden');
    if (backdrop) backdrop.classList.add('is-open');
    document.documentElement.classList.add('cf-no-scroll');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var focusTarget = panel.querySelector('[data-autofocus]') || panel.querySelector(FOCUSABLE);
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 60);
    document.addEventListener('keydown', trap);
  }

  function close() {
    if (!openPanel) return;
    openPanel.classList.remove('is-open');
    openPanel.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.classList.remove('is-open');
    document.documentElement.classList.remove('cf-no-scroll');
    document.querySelectorAll('[aria-controls]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
    document.removeEventListener('keydown', trap);
    if (lastFocus) lastFocus.focus();
    openPanel = null;
  }

  /* wire triggers: any [data-open="#panelId"] */
  document.querySelectorAll('[data-open]').forEach(function (trigger) {
    var target = document.querySelector(trigger.getAttribute('data-open'));
    if (!target) return;
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (target === openPanel) { close(); } else { open(target, trigger); }
    });
  });

  /* close buttons + backdrop */
  document.querySelectorAll('[data-close]').forEach(function (btn) {
    btn.addEventListener('click', close);
  });
  if (backdrop) backdrop.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();
